// TODO: move to main utils
// NOT USED?
// export const getSelectedOperationModes = ({
//     operation_modes,
//     device_types
// }) => {
//     let res = []
//     if (device_types.includes('jerry')) {
//         res.push('jerry:snaptrap')
//     }
//     if (device_types.includes('tom')) {
//         operation_modes.forEach(el => {
//             res.push(`tom:${el}`)
//         })
//     }
//     return res
// }

export const compareDateStringsDesc = (date1, date2) => {
    return new Date(date2) - new Date(date1)
}
